import { Signal } from "signals";
import { IAdBreakDonePlacementInfo, IGameSnacks } from "./GameSnacks";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class AdManager
{
    private _showAdFn: () => any = null;

    private _reward: any = null;

    private _adBreakTimeout: number = null;

    private _isShowingAd: boolean = null;

    private _onAdReady: Signal = null;
    private _onAdLost: Signal = null;
    private _onAdCompleted: Signal = null;


    public get isShowingAd(): boolean { return this._isShowingAd; }

    public get onAdReady(): Signal { return this._onAdReady; }
    public get onAdLost(): Signal { return this._onAdLost; }
    public get onAdCompleted(): Signal { return this._onAdCompleted; }


    public constructor() {}

    public init(): void
    {
        this._onAdReady = new Signal();
        this._onAdLost = new Signal();
        this._onAdCompleted = new Signal();

        this._isShowingAd = false;
    }

    public prepare(): void
    {
        if ( window.GameSnacks )
        {
            if ( this._showAdFn )
            {
                this._onAdReady.dispatch();
            }
            else
            {
                this._adBreakTimeout = window.setTimeout( () => {
                    this._onAdLost.dispatch();
                }, 1000 );

                window.GameSnacks.ad.break( {
                    type: "reward",
                    name: "rewarded_ad",
                    beforeReward: this.onRewardedAdOpportunity_BeforeReward.bind( this ),
                    beforeAd: this.onRewardedAdOpportunity_BeforeBreak.bind( this ),
                    adDismissed: () => {},
                    adViewed: () => {},
                    adBreakDone: this.onRewardedAdOpportunity_AdBreakDone.bind( this ) } );
            }
        }
        else
        {
            this._onAdReady.dispatch();
        }
    }

            private onRewardedAdOpportunity_BeforeReward( showAdFn: () => any ): void
            {
                // Show reward UI. Call showAdFn() if clicked.
                this._showAdFn = showAdFn;

                if ( this._adBreakTimeout )
                {
                    window.clearInterval( this._adBreakTimeout );
                    this._adBreakTimeout = null;
                }

                this._onAdReady.dispatch();
            }

            private onRewardedAdOpportunity_BeforeBreak(): void
            {
                // Mute the game.
                Howler.mute( true );

                this._isShowingAd = true;
            }

            private onRewardedAdOpportunity_AdBreakDone( placementInfo: IAdBreakDonePlacementInfo ): void
            {
                this._showAdFn = null;

                if ( placementInfo.breakStatus == "viewed" )
                {
                    this._onAdCompleted.dispatch( this._reward );
                }
                else
                {
                    this._onAdLost.dispatch();
                }

                this._reward = null;

                if ( this._adBreakTimeout )
                {
                    window.clearInterval( this._adBreakTimeout );
                    this._adBreakTimeout = null;
                }

                // Unmute the game.
                Howler.mute( !window.GameSnacks.audio.isEnabled() );

                this._isShowingAd = false;
            }

    public end(): void
    {
        this._onAdLost.dispose();
        this._onAdLost = null;

        this._onAdReady.dispose();
        this._onAdReady = null;

        this._onAdCompleted.dispose();
        this._onAdCompleted = null;

        if ( this._adBreakTimeout )
        {
            window.clearInterval( this._adBreakTimeout );
            this._adBreakTimeout = null;
        }
    }

    public watch( reward: any ): void
    {
        if ( window.GameSnacks )
        {
            this._reward = reward;

            this._showAdFn.call( null );
        }
        else
        {
            this._onAdCompleted.dispatch( reward );
        }
    }

    public isAdReady(): boolean
    {
        let result: boolean = true;

        if ( window.GameSnacks )
        {
            result = this._showAdFn != null;
        }
        
        return result;
    }
}